import { h, Component } from 'preact';

import Store from 'store/store';

import { sortObjectByOrder, joinClasses, accessNested } from 'utils/utils';
// import { smoothScrollTo } from 'utils/smoothScroll';
import { powsterHeaderLogo, socialIcons, mailIcon } from 'components/shared/svgIcons/icons';

import s from 'components/shared/header/header.sss';


export default class Header extends Component {
	constructor(props) {
		super(props);

		this.renderItem = this.renderItem.bind(this);
		// this.mouseOverLink = this.mouseOverLink.bind(this);
		this.toggleMenu = this.toggleMenu.bind(this);
		this.handleScroll = this.handleScroll.bind(this);
		this.goToMainPage = this.selectPage.bind(this, 'main');

		this.state = {
			menuOpen: false,
			headerVisible: false,
			hiddenHeaderBar: false,
			scrollOut: false,
			landingInView: true,
		};
	}

	componentDidMount() {
		Store.on('SHOW_SITE', this.showHeader);
		// window.addEventListener('touchmove', this.handleScroll);
		window.addEventListener('scroll', this.handleScroll);
		Store.on('UPDATED_PAGE_LOADER_COMPONENT', this.handleScroll);
		this.handleScroll();
	}

	componentWillUnmount() {
		// window.removeEventListener('touchmove', this.handleScroll);
		window.removeEventListener('scroll', this.handleScroll);
		Store.off('UPDATED_PAGE_LOADER_COMPONENT', this.handleScroll);
	}

	componentWillReceiveProps(nextProps) {
		if (!this.shouldUseBurger(nextProps) && this.state.menuOpen) {
			this.toggleMenu(false);
		}
	}

	shouldUseBurger(props) {
		return accessNested(Store.get(), 'client.dimensions.width', 0) < 1024;
	}

	isScrolledPast(el, bottomMargin) {
		let rect = el.getBoundingClientRect();
		return rect.bottom > bottomMargin;
	}

	handleScroll() {
		const landing = document.querySelector('#landing');
		// 64 = header top banner height
		const landingInView = !!landing && this.isScrolledPast(landing, this.base.offsetTop + 64);
		if (landingInView !== this.state.landingInView) {
			this.setState({ landingInView: landingInView });
		}
		const currentScrollPos = window.pageYOffset;
		let prevScrollPos = this.prevScrollPos || currentScrollPos;
		if (this.state.scrollOut && (currentScrollPos < 5 || currentScrollPos < prevScrollPos - 5)) {
			this.setState({ scrollOut: false });
		} else if (!this.state.scrollOut && currentScrollPos >= 5 && currentScrollPos > prevScrollPos + 20) {
			this.setState({ scrollOut: true });
		}
		this.prevScrollPos = Math.max(currentScrollPos - 20, Math.min(currentScrollPos + 5, prevScrollPos));
	}

	showHeader() {
		this.setState({ headerVisible: true });
	}

	selectPage(page) {
		Store.emit('SET_ACTIVE_PAGE', page);
		this.toggleMenu(false);
	}

	renderItem(item) {
		let id = item.id;
		let active = id === this.props.activePage;
		let text = item.text || id;
		return <button class={joinClasses(s.item, s.page, active && s.active)} onClick={() => this.selectPage(id)} key={id}>{text}</button>;
	}

	toggleMenu(menuOpen) {
		if (typeof menuOpen !== 'boolean') {
			menuOpen = !this.state.menuOpen;
		}
		Store.emit('HEADER_TOGGLE', menuOpen);
		this.setState({ menuOpen });
	}

	render(props, state) {
		const { header } = props.appData;
		const menuContent = sortObjectByOrder(header.nav);
		const socials = props.socials || [];
		const imageRoot = accessNested(props, 'appData.urls.roots.image');

		const { scrollOut, landingInView, menuOpen, headerVisible } = state;

		const contactButton = (
			<button class={s.mail} onClick={() => Store.emit('SET_ACTIVE_PAGE', 'contact')} key="contact-icon">
				{mailIcon}
			</button>
		);
		let barRight = [
			contactButton,
			<div class={s.separator} key="sep" />,
			<button class={s.burger} onClick={this.toggleMenu} key="burger">
				<span class={joinClasses(s.line, s.top)} />
				<span class={joinClasses(s.line, s.mid)} />
				<span class={joinClasses(s.line, s.bottom)} />
			</button>
		];
		if (!this.shouldUseBurger()) {
			barRight = [
				...menuContent.map(this.renderItem)
			];
		}

		const hide = scrollOut && !menuOpen;

		// Ability to change the logo and menu color when in a case study page
		// (when over the top landing picture)

		const currentPageData = props.appData.pages[props.activePage];
		let logoColor;
		let barRightColor;
		if (currentPageData.component === 'caseStudy') {
			logoColor = currentPageData.data.headerLogoColor;
			barRightColor = currentPageData.data.headerMenuColor;
		}
		const extraLogoStyle = landingInView && logoColor ? { color: logoColor } : {};
		const extraBarRightStyle = landingInView && barRightColor ? { color: barRightColor } : {};

		return (
			<header id="header" class={joinClasses(s.wrapper, hide && s.hide, menuOpen && s.menuOpen, landingInView && s.landingInView)}>
				<div class={s.menu} ref={ref => this.$menu = ref}>
					<img class={s.monogram} src={`${imageRoot}/monogram.svg`}/>
					<div class={s.menuContent}>
						{menuContent.map(this.renderItem)}
						<div class={joinClasses(s.item, s.socials)}>
							{socials.map(({ id, href }) => <a class={s.social} href={href} target="_blank">{socialIcons[id]}</a>)}
						</div>
					</div>
				</div>
				<div class={joinClasses(s.bar, headerVisible && s.show)}>
					<button class={s.logo} style={extraLogoStyle} onClick={this.goToMainPage}>
						{powsterHeaderLogo}
					</button>
					<div class={s.right} style={extraBarRightStyle}>{barRight}</div>
				</div>
			</header>
		);
	}
}
